import React, { memo, useLayoutEffect, useRef, useState } from "react";
import { useEffect } from "react";

const OK = "#008101";
const NG = "#d80707";
const OK_DISPLAY = "rgb(0,129,1,0.5)";
const NG_DISPLAY = "rgb(216,7,7,0.5)";
const colorTextCavas = "white";
const IMG_W = 250;
const IMG_H = 450;
// const FONT = "bold 20px sans-serif";
const FONT = "1rem sans-serif";

export const PanelCanvas = memo(
  ({ imgBase64, parts = [], zoomable = false }) => {
    const dx = 20;
    const dy = 60;
    const [isPhone, setPhone] = useState(window.innerWidth < 500);
    const [wsize, setwSize] = useState(
      zoomable
        ? { X: window.innerWidth, Y: window.innerHeight }
        : { X: 250, Y: 450 }
    );
    const scale = calcScale(wsize);
    const canvasRef = useRef(null);
    const canvasImgRef = useRef(null);
    const [imgBase64Detect, setImgBase64Detect] = useState();
    const [_clickedPoint, set_clickedPoint] = useState();
    const [_transformation, set_transformation] = useState(
      new ProTransformation({ X: 0, Y: 0 }, scale)
    );
    useEffect(() => {
      setImgBase64Detect(imgBase64);
      return;
      if (!imgBase64) return;
      const canvas = canvasImgRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = imgBase64;
      img.onload = function () {
        var l_scale = 1;
        var imgSize = { w: IMG_W / l_scale, h: IMG_H / l_scale };
        var partSize = { w: 162, h: 36 };
        var container = {
          w: imgSize.w + 20 + 40 + partSize.w,
          h: imgSize.h + 20,
        };
        canvas.width = imgSize.w;
        canvas.height = imgSize.h;
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, container.w, container.h);
        var dx = 0;
        var dy = 0;
        var w = IMG_W;
        var h = IMG_H;
        var x = 0;
        var y = 0;
        ctx.drawImage(img, x, y, w, h, dx, dy, imgSize.w, imgSize.h);
        // draw parts
        parts &&
          parts
            .toSorted((p1, p2) => p1.name.localeCompare(p2.name))
            .forEach((p, i) => {
              drawRoundRectDetect(
                ctx,
                {
                  x: p.pos.x / l_scale,
                  y: p.pos.y / l_scale,
                  w: p.pos.width / l_scale,
                  h: p.pos.height / l_scale,
                  r: 2,
                },
                p
              );
            });
        setImgBase64Detect(canvas.toDataURL("image/jpeg", 0.5));
      };
    }, [imgBase64, parts]);

    useLayoutEffect(() => {
      if (!zoomable) return;

      function updateSize() {
        console.log(window.innerWidth, window.innerHeight);
        setPhone(window.innerWidth < 500);
        setwSize({ X: window.innerWidth, Y: window.innerHeight });
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, [zoomable]);

    useEffect(() => {
      if (!imgBase64Detect) return;
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = imgBase64Detect;
      img.onload = function () {
        var judgeSize = { w: 138, h: 91 };
        var partSize = { w: 100, h: 20 };
        var scale2 = calcScale(wsize, isPhone);
        const des = { w: IMG_W / scale2, h: IMG_H / scale2 };
        console.log("des", des);
        //------
        // hdr
        //------
        // img
        //------
        // info
        //------
        var partMargin = { X: 8, Y: 8 };
        const containerPad = { X: 8, Y: 8 };
        
        const nCol = isPhone ? 3 : 1;
        const nRow = isPhone ? Math.ceil(parts.length / 3) : 12;
        const infoSize = isPhone
          ? {
              w: (partSize.w + partMargin.X) * nCol - partMargin.X,
              h: (partSize.h + partMargin.Y) * nRow,
            }
          : {
              w: partSize.w + partMargin.X,
              h: (partSize.h + partMargin.Y) * 12 - partMargin.Y,
            };
        var container = isPhone
          ? {
              w: Math.max(des.w, infoSize.w) + containerPad.X * 2,
              h: des.h + infoSize.h + containerPad.Y * 2,
            }
          : {
              w: des.w + infoSize.w + containerPad.X * 2,
              h: Math.max(des.h, infoSize.h) + containerPad.Y * 2,
            };
        const imgPos = { X: containerPad.X, Y: containerPad.Y };
        const infoPos = isPhone
          ? { X: containerPad.X, Y: container.h - containerPad.Y - infoSize.h }
          : { X: container.w - containerPad.X - infoSize.w, Y: containerPad.Y };
        console.log("container", container);
        canvas.width = container.w;
        canvas.height = container.h;

        // draw container
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, container.w, container.h);

        // draw img
        var dRect = { X: imgPos.X, Y: imgPos.Y, W: des.w, H: des.h };
        var sRect = _transformation.ConvertRectToIm(dRect);
        // console.log("dRect", dRect, "sRect", sRect)
        ctx.drawImage(
          img,
          sRect.X,
          sRect.Y,
          sRect.W,
          sRect.H,
          dRect.X,
          dRect.Y,
          dRect.W,
          dRect.H
        );

        // draw NG/OK
        if (false) {
          const isOk = parts ? parts.every((p) => p.judge) : false;
          const [txt, cl] = isOk ? ["OK", OK] : ["NG", NG];
          drawRoundRect2(
            ctx,
            { x: 20, y: 20, w: judgeSize.w, h: judgeSize.h, r: 20 },
            txt,
            cl,
            "bold 50px sans-serif"
          );
        }
        // draw parts
        var infoClientPos = isPhone
          ? {
              X: infoPos.X,
              Y: infoPos.Y + partMargin.Y,
            }
          : { X: infoPos.X + partMargin.X, Y: infoPos.Y };

        var sorted = parts.toSorted((p1, p2) => p1.name.localeCompare(p2.name));
        for (var i in sorted) {
          var p = sorted[i];
          var iRow = Math.floor(i / nCol);
          var iCol = i % nCol;
          drawRoundRect2(
            ctx,
            {
              x: infoClientPos.X + iCol * (partSize.w + partMargin.X),
              y: infoClientPos.Y + iRow * (partSize.h + partMargin.Y), // adjust padding
              w: partSize.w,
              h: partSize.h,
              r: 10,
            },
            p.name,
            p.judge ? OK : NG,
            FONT
          );
        }
      };
    }, [imgBase64, parts, _transformation, imgBase64Detect, wsize, isPhone]);

    function wheelHandler(e) {
      var transformation = new ProTransformation(
        _transformation._translation,
        _transformation._scale
      );
      var location = getLocation(e);
      var pos1 = transformation.ConvertToIm(location);
      if (e.deltaY < 0)
        transformation = transformation.SetScale(transformation.Scale / 1.25);
      else
        transformation = transformation.SetScale(transformation.Scale * 1.25);

      var pos2 = transformation.ConvertToIm(location);
      transformation = transformation.AddTranslate({
        X: pos1.X - pos2.X,
        Y: pos1.Y - pos2.Y,
      });

      set_transformation(transformation);
    }

    function moveHandler(e) {
      if (_clickedPoint) {
        var location = getLocation(e);
        var size = _transformation.ConvertSizeToIm(location);
        var transformation = _transformation.SetTranslate({
          X: _clickedPoint.X - size.X,
          Y: _clickedPoint.Y - size.Y,
        });
        set_transformation(transformation);
      }
    }

    function getLocation(e) {
      var viewportOffset = e.target.getBoundingClientRect();
      // these are relative to the viewport, i.e. the window
      var top = viewportOffset.top;
      var left = viewportOffset.left;
      var X = e.clientX - left;
      var Y = e.clientY - top;
      return { X, Y };
    }
    function downHandler(e) {
      var location = getLocation(e);
      var pos = _transformation.ConvertToIm(location);
      set_clickedPoint(pos);
    }

    function upHandler(e) {
      set_clickedPoint(null);
    }
    return zoomable ? (
      <div
        style={{
          outline: "solid 1px #f16511",
          outlineOffset: "-1px",
          borderRadius: "1rem",
        }}
      >
        <canvas
          ref={canvasRef}
          style={{ width: "100%" }}
          onMouseMove={moveHandler}
          onMouseDown={downHandler}
          onMouseUp={upHandler}
          onWheel={wheelHandler}
        ></canvas>
        <canvas
          ref={canvasImgRef}
          style={{ maxWidth: "100%", display: "none" }}
        ></canvas>
      </div>
    ) : (
      <div>
        <canvas ref={canvasRef} style={{ maxWidth: "100%" }}></canvas>
        <canvas
          ref={canvasImgRef}
          style={{ maxWidth: "100%", display: "none" }}
        ></canvas>
      </div>
    );
  }
);

function calcScale(wsize, isPhone = false) {
  var padding = isPhone
    ? {
        X: 0,
        Y: 200,
      }
    : { X: 0, Y: 200 };
  var wh = wsize.Y - padding.Y;
  var ww = wsize.X - padding.X;
  var scale2 = Math.max(IMG_W / ww, IMG_H / wh);
  return scale2;
}

class ProTransformation {
  get Translation() {
    return this._translation;
  }
  get Scale() {
    return this._scale;
  }
  _translation;
  _scale;
  constructor(translation, scale) {
    this._translation = translation;
    this._scale = scale;
  }
  ConvertToIm(p) {
    return {
      X: p.X * this._scale + this._translation.X,
      Y: p.Y * this._scale + this._translation.Y,
    };
  }
  ConvertSizeToIm(p) {
    return {
      X: p.X * this._scale,
      Y: p.Y * this._scale,
    };
  }
  SetTranslate(p) {
    return new ProTransformation(p, this._scale);
  }
  SetScale(scale) {
    return new ProTransformation(this._translation, scale);
  }
  AddTranslate({ X, Y }) {
    return this.SetTranslate({
      X: X + this._translation.X,
      Y: Y + this._translation.Y,
    });
  }
  ConvertRectToIm({ X, Y, W, H }) {
    var location = this.ConvertToIm({ X, Y });
    var size = this.ConvertSizeToIm({ X: W, Y: H });
    return { X: location.X, Y: location.Y, W: size.X, H: size.Y };
  }
}

function drawRoundRect2(ctx, { x, y, w, h, r }, txt, cl, font) {
  ctx.font = font;
  ctx.textBaseline = "top";
  ctx.textAlign = "left";
  const text = ctx.measureText(txt);
  var tw = text.width;
  var th = text.actualBoundingBoxDescent;

  var rectHeight = h;
  var rectWidth = w;

  ctx.fillStyle = cl;
  ctx.beginPath();
  ctx.roundRect(x, y, rectWidth, rectHeight, r);
  ctx.fill();

  ctx.fillStyle = "white";
  ctx.fillText(txt, x + (rectWidth - tw) / 2, y + (rectHeight - th) / 2);
}

const drawRoundRectDetect = (ctx, { x, y, w, h, r }, p) => {
  var rectHeight = h;
  var rectWidth = w;
  var color = p.judge ? OK_DISPLAY : NG_DISPLAY;
  ctx.beginPath();
  ctx.roundRect(x, y, rectWidth, rectHeight, r);

  ctx.lineWidth = 10;
  ctx.strokeStyle = color;
  ctx.stroke();
};

const drawRoundRectLabel = (ctx, { x, y }, p, parts, imgSize) => {
  ctx.font = "60px sans-serif";
  ctx.textBaseline = "top";
  ctx.textAlign = "left";

  const currentLabel = {
    x: x - 5,
    y: y - 65,
    w: ctx.measureText(p.name).width + 5,
    h: 60,
  };
  const frameRec = {
    x: p.pos.x,
    y: p.pos.y,
    w: p.pos.width,
    h: p.pos.height,
  };
  parts.forEach((o) => {
    const otherLabel = {
      x: o.pos.x - 5,
      y: o.pos.y - 65,
      w: ctx.measureText(o.name).width + 5,
      h: 60,
    };
    const otherRec = {
      x: o.pos.x,
      y: o.pos.y,
      w: o.pos.width,
      h: o.pos.height,
    };
    if (
      p.name !== o.name &&
      !isRectContain(frameRec, otherRec) &&
      intersectsWith(currentLabel, otherRec)
    ) {
      if (currentLabel.x > otherRec.x) {
        currentLabel.x += calculateDistance(frameRec, otherRec);
      } else {
        currentLabel.x -=
          currentLabel.w - calculateDistance(frameRec, otherRec);
      }
    }
    if (p.name !== o.name && intersectsWith(currentLabel, otherLabel)) {
      if (currentLabel.x > otherLabel.x) {
        currentLabel.x += calculateDistance(currentLabel, otherLabel);
      } else {
        currentLabel.x -=
          currentLabel.w - calculateDistance(currentLabel, otherLabel);
      }
    }
    currentLabel.x = currentLabel.x < 0 ? 0 : currentLabel.x;
    currentLabel.x =
      currentLabel.x > imgSize.Width ? imgSize.Width : currentLabel.x;
    currentLabel.x = getOverX(currentLabel, frameRec);
  });
  var color = p.judge ? OK_DISPLAY : NG_DISPLAY;
  drawNewLabel(ctx, currentLabel, p.name, color);
};
function getOverX(labelRec, frameRec) {
  return labelRec.x > frameRec.x + frameRec.w
    ? frameRec.x + frameRec.w
    : labelRec.x + labelRec.w < frameRec.x
    ? frameRec.x - labelRec.w
    : labelRec.x;
}
function drawNewLabel(ctx, currentLabel, name, color) {
  ctx.fillStyle = color;
  ctx.fillRect(currentLabel.x, currentLabel.y, currentLabel.w, currentLabel.h);
  ctx.fillStyle = colorTextCavas;
  ctx.fillText(`${name}`, currentLabel.x, currentLabel.y);
}
function intersectsWith(a, b) {
  return !(
    a.x + a.w < b.x ||
    a.x > b.x + b.w ||
    a.y + a.h < b.y ||
    a.y > b.y + b.h
  );
}

function isRectContain(child, parents) {
  return (
    parents.x <= child.x &&
    parents.y <= child.y &&
    parents.x + parents.w >= child.x + child.w &&
    parents.y + parents.h >= child.y + child.h
  );
}

function calculateDistance(childRectangle, parentRectangle) {
  var closestX =
    childRectangle.x < parentRectangle.x
      ? parentRectangle.x
      : parentRectangle.x + parentRectangle.w;
  var closestY = childRectangle.y;
  var distance = Math.sqrt(
    Math.pow(closestX - childRectangle.x, 2) +
      Math.pow(closestY - childRectangle.y, 2)
  );
  return distance;
}
